export const validatePhoneNumber = (phone, setPhoneError) => {
  if (!phone) {
    setPhoneError('Unesite broj telefona!');
  } else if (!/^(\+381|0)[1-9]\d{6,12}$/.test(phone)) {
    setPhoneError(
      'Unesite ispravan broj telefona (npr. +3816xxxxxxx ili 06xxxxxxx)!'
    );
  } else {
    setPhoneError(null);
  }
};
